import { fetchCandidateRows } from '@/views/vehicle-monitor/nativeVehicleMonitoringApi'
import { authState, hasPermission } from '@/utils/auth'

const SUGGEST_LIMIT = 50

export async function fetchAuthorizedVehicleCandidates(query = '') {
  const actor = authState.user
  if (!actor || !hasPermission('vehicle:list')) return []
  try {
    const rows = await fetchCandidateRows(query)
    return authState.user === actor && hasPermission('vehicle:list') ? rows : []
  } catch (error) {
    if (authState.user !== actor || !hasPermission('vehicle:list')) return []
    throw error
  }
}

/** 车牌颜色：1 蓝 / 2 黄 / 3 绿，无效或空则默认 2（黄） */
export function normalizeVehiclePlateColor(raw) {
  const v = raw != null && String(raw).trim() !== '' ? String(raw).trim() : ''
  if (v === '1' || v === '2' || v === '3') return v
  return '2'
}

export function resolveVehiclePlateColor(row) {
  if (!row) return '2'
  return normalizeVehiclePlateColor(row.vehiclePlateColor)
}

export const BATCH_PLATE_IMPORT_PLACEHOLDER = '请输入车牌号，车牌号之间以英文逗号分割'

/** 批量识别车牌：英文/中文逗号或换行分隔；无显式颜色时按位数推断（7→黄2，8→黄绿3） */
export function parseBatchPlateImportText(text) {
  const s = text != null ? String(text) : ''
  const normalized = s.replace(/[\n\r]+/g, ',').replace(/，/g, ',')
  const out = []
  for (const seg of normalized.split(',')) {
    const token = String(seg || '').trim()
    if (!token) continue
    const last = token.lastIndexOf('_')
    if (last <= 0) {
      out.push({ vclN: token, vco: resolveVcoForQuery(token) })
      continue
    }
    const plate = token.slice(0, last).trim()
    const vcoPart = token.slice(last + 1).trim()
    const vco =
      vcoPart === '1' || vcoPart === '2' || vcoPart === '3'
        ? vcoPart
        : resolveVcoForQuery(plate)
    out.push({ vclN: plate, vco })
  }
  return out
}

/** 轨迹/定位查询 vco：优先 vehiclePlateColor，无则 7 位牌→2、8 位→3，默认 2 */
export function resolveVcoForQuery(vehicleNo, vehiclePlateColor) {
  const colorRaw =
    vehiclePlateColor != null && String(vehiclePlateColor).trim() !== ''
      ? String(vehiclePlateColor).trim()
      : ''
  if (colorRaw === '1' || colorRaw === '2' || colorRaw === '3') return colorRaw
  const plate = vehicleNo != null ? String(vehicleNo).trim() : ''
  if (plate.length === 8) return '3'
  if (plate.length === 7) return '2'
  return '2'
}

/** 车牌号_颜色码，用于需带 vco 的列表筛选 */
export function formatVehicleNoWithPlateColor(vehicleNo, vehiclePlateColor) {
  const plate = vehicleNo != null ? String(vehicleNo).trim() : ''
  if (!plate) return ''
  return `${plate}_${resolveVcoForQuery(plate, vehiclePlateColor)}`
}

async function loadVehicleRows(query = '') {
 const rows = await fetchAuthorizedVehicleCandidates(query); const byNo = new Map();
 rows.forEach(row => { if (rows.filter(item => item.vehicleNo === row.vehicleNo).length === 1) byNo.set(row.vehicleNo, row) });
 return { rows, byNo }
}

/**
 * 车牌模糊联想：contacts 为空时返回前 SUGGEST_LIMIT 条
 * @returns {Promise<Array<{ value: string, label: string, vehiclePlateColor: string }>>}
 */
export async function fetchVehicleNoSuggestions(queryString) {
  const query = queryString != null ? String(queryString).trim() : ''
  const { rows } = await loadVehicleRows(query)
  const q = query.toLowerCase()
  const filtered = q
    ? rows.filter((r) => String(r.vehicleNo || '').toLowerCase().includes(q))
    : rows
  return filtered.slice(0, SUGGEST_LIMIT).map((r) => ({
    value: String(r.vehicleNo),
    label: String(r.vehicleNo),
    vehiclePlateColor: resolveVehiclePlateColor(r)
  }))
}

export async function getVehiclePlateColorByNo(vehicleNo) {
  const no = vehicleNo != null ? String(vehicleNo).trim() : ''
  if (!no) return '2'
  const { byNo } = await loadVehicleRows(no)
  const row = byNo.get(no)
  return row ? resolveVehiclePlateColor(row) : '2'
}

export function clearVehicleDataListCache() {}
